import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const _Swal = withReactContent(Swal);

export default _Swal;
